"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.YYYYMMDD_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = void 0;
exports.DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';
exports.YYYYMMDD_DATE_FORMAT = 'yyyyMMdd';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdGFudHMvZGF0ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7QUFFVSxRQUFBLG1CQUFtQixHQUFHLFlBQVksQ0FBQztBQUNuQyxRQUFBLG9CQUFvQixHQUFHLFVBQVUsQ0FBQyJ9